import { render, staticRenderFns } from "./equity.vue?vue&type=template&id=009a875c"
import script from "./equity.vue?vue&type=script&lang=js"
export * from "./equity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/equity-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fproducts%2Fequity.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/equity-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fproducts%2Fequity.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,VueGlideComponent: require('/vercel/path0/components/vue-glide-component.vue').default,StartTradingSteps: require('/vercel/path0/components/StartTradingSteps.vue').default,CtaImage: require('/vercel/path0/components/ui/cta-image.vue').default})
